__turbopack_context__.v({
  "from_franchise": "FromFranchise-module-scss-module__Ufabga__from_franchise",
  "from_franchise__link": "FromFranchise-module-scss-module__Ufabga__from_franchise__link",
});
